import React from 'react';
import { Divider } from '../../common/atoms';
import { Lock, Tick } from '../../../assets/images';
import { dsButtonPrimary, joinButtonClasses } from '../../../utils/buttonStyles';

const UtilizationCard = ({ sectionTitle, image, sectionSubtitle, points, toggleHelp }) => {
  return (
    <div className='mx-auto flex h-auto w-full max-w-6xl flex-col overflow-hidden rounded-xl border border-gray-200 bg-[#FFFCF3] shadow-sm'>
      <div className='flex min-h-[5rem] flex-row items-center gap-4 border-b border-amber-200 bg-yellow-100 px-4 py-4 sm:gap-5 sm:px-8'>
        <img
          src={Lock}
          className='h-12 w-12 shrink-0 sm:h-[70px] sm:w-[70px]'
          width='70'
          height='70'
          alt=''
          aria-hidden
        />
        <div className='min-w-0'>
          <div className='kicker'>Not enabled</div>
          <div className='mt-1 text-xl font-semibold leading-snug tracking-tight text-gray-900 sm:text-2xl'>{sectionTitle}</div>
        </div>
      </div>
      <div className='flex flex-col gap-8 bg-white px-4 py-8 sm:px-8 sm:py-10 lg:flex-row lg:items-start lg:gap-12'>
        <img
          src={image}
          className='mx-auto h-auto w-full max-w-[320px] shrink-0 object-contain lg:mx-0 lg:mr-10'
          width={300}
          alt=''
          aria-hidden
        />
        <div className='mt-2 min-w-0 flex-1 flex-col'>
          <div className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>{sectionSubtitle}</div>
          {points.map((point, key) => {
            return (
              <div
                className='mb-4 flex flex-row gap-3 text-sm leading-relaxed text-gray-700 sm:mb-5 sm:text-base'
                key={`${point}` + key}
              >
                <span className='mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ds-green-lt'>
                  <img src={Tick} className='h-3.5 w-3.5' alt='' />
                </span>
                <span className='min-w-0'>{point}</span>
              </div>
            );
          })}
          {['CSM', 'CSMMaster'].includes(sessionStorage.getItem('role')) ? (
            <div className='mt-8 border-t border-gray-200 pt-8'>
              <Divider classes='hidden' type='horizontal' />
              <p className='mb-0 text-sm leading-relaxed text-gray-600'>
                The HR will reach out to you in case they want to avail this service for their organization
              </p>
            </div>
          ) : (
            <div className='mt-8 rounded-xl border border-blue-200 bg-blue-50/60 px-5 py-5 sm:px-6'>
              <div className='text-sm font-medium leading-relaxed text-gray-800 sm:text-base'>
                Reach out to your Customer Success Manager to learn more
              </div>
              <button
                type='button'
                onClick={toggleHelp}
                className={joinButtonClasses(dsButtonPrimary, 'mt-4 h-10 w-full px-6 sm:w-auto')}
              >
                Send a request
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UtilizationCard;
